<template>
  <div class="animation" ref="animation"></div>
</template>

<script>
import animation from '@/mixins/animation';
import feetPos from '@/assets/animations/feetpos.json';
import feetPosSanne from '@/assets/sanne/animations/feetpos.json';

export default {
  name: 'FeetPos',
  mixins: [animation],
  // same animation and timing in every brand; Sanne gets a recoloured copy
  // (computed getters are not set up yet while data runs, so read the store)
  data() {
    return {
      animationData: this.$store.getters['app/isSanne'] ? feetPosSanne : feetPos,
      autoPlay: true,
    };
  },
};
</script>

<style lang="scss" scoped></style>
